export const ticketManagement = {
  ticketManager: 'บริหารจัดการคำขอต่างๆ',
  search: 'ค้นหาตั๋ว',
  advanceFilter: 'ตัวกรองขั้นสูง',
  createTicket: 'คำขอที่ต้องการ',
  ticketId: 'Ticket ID',
  ticketTopic: 'คำขอ',
  ticketName: 'ชื่อตั๋ว',
  ticketOwner: 'เจ้าของตั๋ว',
  ticketDescription:'รายละเอียดของตั๋ว',
  ticketImage:'รูป',
  ticketComment:'คอมเมนต์',
  status: 'สถานะ',
  cancel: 'ยกเลิก',
  filter: 'ตัวกรอง',
  createdAt: 'สร้างเวลา',
  ticketExample:'ตัวอย่างสร้างคำขอนี้',
  userUsername:'ชื่อผู้ใช้งาน',
  upload:'อัปโหลด รูปหรือวีดีโอ',
  send: "ส่ง",
  export:'ส่งออก',
  cancelTicket: 'ยกเลิกคำขอ',
  reason:'เหตุผล',
  confirm:'ยืนยัน',
  uploadFile:'อัปโหลดไฟล์',
  fileSizeExpect:'ไฟลต้องไม่เกิน 10 MB',
  formList: {
    updateChangeRoleAdmin: 'ขอเปลี่ยนแปลงตำแหน่งงานยูเซอร์แอดมิน',
    checkBetSettled: 'ตรวจสอบรายการวางเดิมพัน หรือ ตรวจสอบผลการเดิมพัน',
    changeBankAccountName: 'ขอแก้ไขชื่อบัญชีลูกค้า',
    changeUsername: 'ขอเปลี่ยนเบอร์มือถือลูกค้า',
    inactiveUserAdmin: 'ขอระงับการใช้งานยูเซอร์แอดมิน',
    createNewUserAdmin: 'ขอสร้างยูเซอร์แอดมินคนใหม่',
    changeBankAccountNo: 'ขอแก้ไขเลขที่บัญชีลูกค้า',
    betNotSettled: 'ตรวจสอบรายการที่ไม่จบเดิมพัน',
    addRemoveOperationList: 'ขอเพิ่มหรือขอลบเวป ออกจากแอดมิน',
    updateLineOa: 'ขอเปลี่ยน LINE@',
    cantPlaygame: 'แจ้งเล่นเกมไม่ได้',
    checkCommissionAffiliate: 'เช็คยอดคอมมิชชั่นหรือค่าพันธมิตร',
    clearHoldBalance: 'ขอเคลียร์ยอดติด',
    requestChangeUsernamePasswordAdmin: 'แอดมินขอเปลี่ยนพาสเวิร์ด',
    adminRequestResetgoogleAuth: 'แอดมินขอรีเซทกูเกิ้ล ออเทน',
    adminRequestResetMobileNo: 'แอดมินขอรีเซทเบอร์มือถือ.',
    depositAndWithdrawNotFound: 'แจ้งไม่พบรายการฝากหรือถอนที่ CMS',
    updateWithdrawLimit: 'ปรับจำนวนครั้งการถอนต่อวัน',
    updateValidBalance: 'ขอปรับเพิ่มหรือลด Valid Balance',
    loyaltyPoint: 'แจ้งปัญหา Loyalty Point',
    other: 'คำขออื่นๆ',
    field: {
      settleValue: 'เงินเดิมพัน(settle)',
      exampleTicket:'ตัวอย่างสร้างคำขอนี้',
      currentBankName: 'ชื่อธนาคารปัจจุบัน',
      request: 'คำขอ',
      username: 'ยูเซอร์แอดมินที่ต้องการเปลี่ยน',
      userAdmin:'ยูเซอร์แอดมิน',
      customerUsername: 'หมายเลขมือถือลูกค้า',
      currentRole: 'ตำแหน่งงานปัจจุบัน',
      newRole: 'ตำแหน่งงานใหม่ที่ต้องการ',
      pictureReferFromOper: 'ภาพอ้างอิงต่างๆ',
      operatorName: 'ชื่อเวป',
      providerName: 'ชื่อค่ายเกมที่ต้องการส่งตรวจสอบ',
      gameName: 'ชื่อเกมที่เล่นไม่ได้',
      gameId: 'Game Id',
      gameIdDateTime: 'Game Id วันที่และเวลา',
      currentUsername: 'หมายเลขมือถือลูกค้าปัจจุบัน',
      newUsername: 'หมายเลขมือถือลูกค้าใหม่',
      role: 'ตำแหน่งงานที่ต้องการ',
      opernameToUse: 'ชื่อผู้ปฏิบัติที่ใช้',
      adminName: 'ชื่อแอดมินที่ต้องการสร้างใหม่',
      password: 'รหัสผ่าน',
      pictureRefer: 'รูปภาพอ้างอิง ',
   currentBankAccountName:'ชื่อบัญชีปัจจุบัน',
      newBankAccountName:'ชื่อบัญชีใหม่',
      newBankName: 'ชื่อธนาคารใหม่ที่ต้องการ',
      currentAccountNo: 'เลขบัญชีปัจจุบัน',
      newAccountNo: 'หมายเลขบัญชีใหม่ที่ต้องการ',
      checkBandAccount: 'ชื่อธนาคาร',
      newBankAccountNo: 'เลขบัญชีใหม่',
      currentBankAccountNo:'เลขบัญชีปัจจุบัน',
      currentOperList: 'รายการ Operator ปัจจุบัน',
      newOperList: 'รายการ Operator ใหม่',
      newLinkLineOa: 'ลิงค์ Line ใหม่',
      newNameLine: 'ชื่อ LINE',
      qrcodeLine: 'รหัส QR ของไลน์',
      error: 'ข้อผิดพลาด',
      pictureReferFromUser: 'ภาพอ้างอิงจากผู้ใช้',
      dateForCheck: 'วันที่สำหรับการตรวจสอบ',
      totalHoldBalance: 'ยอดเงินที่ต้องการให้ตรวจสอบ',
      pictureReferFromRTB: 'ภาพอ้างอิงจาก RTB',
      reason: 'เหตุผล',
      newPassword: 'รหัสผ่านใหม่',
      userAlias: 'User Alias',
      newTelephoneNumber:"เบอร์มือถือใหม่",
      issueDetails:'อธิบายรายละเอียด',
      gameRound:'Game Round',
      remark: 'อธิบายรายละเอียด (ถ้ามี)',
      title: 'หัวข้อ',
      amountAdjust: 'จำนวนเงินที่ต้องการปรับ',
      timesAdjust: 'จำนวนครั้งที่ต้องการปรับ',
      amountType: 'ประเภท',
      currentAddress: 'ข้อมูลปัจจุบันลูกค้า',
      issueType: 'โปรดระบุปัญหาที่ให้ตรวจสอบ',
      loyaltyAmount: 'จำนวน Loyalty point ที่ส่งตรวจสอบ',
      amountToCheck:"ยอดเงินที่ต้องการให้ตรวจสอบ",
      usernameEdit: 'ยูเซอร์แอดมินที่ต้องการแก้ไข',
      pleaseSpecifyOperatorName: 'โปรระบุรายชื่อเว็บที่ต้องการ',
      pleaseSpecifyPaymentGateway: 'โปรระบุ Payment gateway',
      dateTimeTransaction: 'วันและเวลาที่ทำรายการ',
      refCodePaymentGateway: 'รหัสอ้างอิง (ref code) BO Payment gateway',
    },
  },
  toastMessage: {
    createError: 'การสร้างตั๋วล้มเหลว',
    missingField: 'ช่องที่ขาดหายไป',
    created: 'สร้างตั๋วสำเร็จ',
  },
}
